import axios from 'axios';
import axiosInstance from './axiosConfig';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export const DashboardService = {
  getAllStats: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get(`/users/all-data`, {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  getActivityLogs: async (page = 1, limit = 10, category = 'all') => {
    try {
      const token = localStorage.getItem('accessToken');
      let url = `/users/logs?page=${page}&limit=${limit}`;
      if (category && category !== 'all') {
        url += `&category=${category}`;
      }
      const response = await axiosInstance.get(url, {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      throw error;
    }
  },

  getUserLessonProgress: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get('/lessons/userProgress?mode=summary', {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user lesson progress:', error);
      throw error;
    }
  },

  viewEmployee: async (restaurantId) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axiosInstance.get(`users/view-employees/${restaurantId}/employees`, {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },

  getAllDirectors: async (page, limit, search, activityLevel, completionRate) => {
    try {
      limit = limit || 10;
      const token = localStorage.getItem('accessToken');
      let url = `/users/directors?page=${page}&limit=${limit}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (activityLevel) url += `&activityLevel=${encodeURIComponent(activityLevel)}`;
      if (completionRate) url += `&completionRate=${encodeURIComponent(completionRate)}`;

      const response = await axiosInstance.get(url, {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching directors:', error);
      throw error;
    }
  },

  getSuperAdminAnalytics: async (timeframe) => {
    try {
      const token = localStorage.getItem('accessToken');
      let url = `/users/super-admin-analytics`;
      if (timeframe) {
        url += `?timeframe=${timeframe}`;
      }
      const response = await axiosInstance.get(url, {
        headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "true",
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching super admin analytics:', error);
      throw error;
    }
  },
};